require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./apis-and-microservices-basic-node-and-express-use-the-env-file.json") })
        }
      }, "path---apis-and-microservices-basic-node-and-express-use-the-env-file");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---apis-and-microservices-basic-node-and-express-use-the-env-file!./.cache/json/apis-and-microservices-basic-node-and-express-use-the-env-file.json
// module id = 1264
// module chunks = 231608221292675